import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetStatusChangedHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetStatusChangedHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetStatusChangedHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetStatusChangedHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type AssetStatusChangedHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type AssetStatusChangedHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetStatusChangedHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetStatusChangedHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetStatusChangedHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetStatusChangedHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetStatusChangedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetStatusChangedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetStatusChangedHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetStatusChangedHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetStatusChangedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetStatusChangedHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetStatusChangedHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetStatusChangedHeaderFragment = AssetStatusChangedHeader_NotificationGroupAccessRequestApproved_Fragment | AssetStatusChangedHeader_NotificationGroupAccessRequestDenied_Fragment | AssetStatusChangedHeader_NotificationGroupAccessRequestSubmitted_Fragment | AssetStatusChangedHeader_NotificationGroupAssetAssignedToYou_Fragment | AssetStatusChangedHeader_NotificationGroupAssetStatusChanged_Fragment | AssetStatusChangedHeader_NotificationGroupCommentCreated_Fragment | AssetStatusChangedHeader_NotificationGroupCommentCreatedShareAccess_Fragment | AssetStatusChangedHeader_NotificationGroupFileUploaded_Fragment | AssetStatusChangedHeader_NotificationGroupReplyCreated_Fragment | AssetStatusChangedHeader_NotificationGroupReplyCreatedShareAccess_Fragment | AssetStatusChangedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetStatusChangedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetStatusChangedHeader_NotificationGroupTranscriptCompletedSelf_Fragment | AssetStatusChangedHeader_NotificationGroupTransferBatchCompleted_Fragment | AssetStatusChangedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetStatusChangedHeader_NotificationGroupUserMentioned_Fragment | AssetStatusChangedHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type AssetStatusChangedHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const AssetStatusChangedHeaderContent = /*#__PURE__*/ gql`
    fragment AssetStatusChangedHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
    ...AssetName
  }
}
    ${UserName}
${Text}
${AssetName}` as unknown as DocumentNode<AssetStatusChangedHeaderContentFragment, unknown>;
export const AssetStatusChangedHeader = /*#__PURE__*/ gql`
    fragment AssetStatusChangedHeader on NotificationGroup {
  ... on NotificationGroupAssetStatusChanged {
    content {
      layout {
        ...AssetStatusChangedHeaderContent
      }
    }
  }
}
    ${AssetStatusChangedHeaderContent}` as unknown as DocumentNode<AssetStatusChangedHeaderFragment, unknown>;

        

        
export const useAssetStatusChangedHeaderFragment = (
  input: string | Omit<UseFragmentOptions<AssetStatusChangedHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetStatusChangedHeaderFragment>({
    fragment: AssetStatusChangedHeader,
    fragmentName: 'AssetStatusChangedHeader',
    ...options,
  });
};
  
        
        

        
export const useAssetStatusChangedHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<AssetStatusChangedHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<AssetStatusChangedHeaderContentFragment>({
    fragment: AssetStatusChangedHeaderContent,
    fragmentName: 'AssetStatusChangedHeaderContent',
    ...options,
  });
};
  
        